import { Component, } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ScreenSizeService } from '../../../../services/utils/screenSize.service';
import { PartnerService } from '../../../partners/clinic-control-panel/clinic-control-panel/services/partner.service';
import { ReviewService } from '../../../../services/review.service';
import { TableUtilsService, } from '@uranda/ui';
import { OpenWriteReviewModalService } from '../../../../services/openWriteReviewModal.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalizedRouterService } from '../../../localized-router.service';
import { ClinicDetailComponent } from './clinic-detail.component';
import { ModalOffcanvasService } from '../../../../services/modal-offcanvas.service';
import { OffcanvasHistoryService } from '../../../../services/offcanvas-history.service';
import {Title} from "@angular/platform-browser";

// @ts-ignore
@Component({
    selector: 'app-clinic-detail',
    templateUrl: './clinic-detail.component.html',
    styleUrls: ['./clinic-detail.component.scss'],
    standalone: false
})
export class ClinicDetailOffcanvasComponent extends ClinicDetailComponent {


  constructor(
    override   route: ActivatedRoute,
    override modalService: NgbModal,
    override offcanvasService: NgbOffcanvas,
    override screenSize: ScreenSizeService,
    override partnerService: PartnerService,
    override reviewService: ReviewService,
    override tableUtils: TableUtilsService,
    override openWriteReviewModalService: OpenWriteReviewModalService,
    override translateService: TranslateService,
    override activatedRoute: ActivatedRoute,
    override modalOffcanvasService: ModalOffcanvasService,
    override localizedRouter: LocalizedRouterService,
    private offcanvasHistory: OffcanvasHistoryService,
    override titleService: Title,
  ) {
    super(
      route,
      modalService,
      offcanvasService,
      screenSize,
      partnerService,
      reviewService,
      tableUtils,
      openWriteReviewModalService,
      translateService,
      activatedRoute,
      localizedRouter,
      modalOffcanvasService,
      titleService
    );
  }

  override async ngOnInit() {
    super.ngOnInit();
  }

  override goBackToSearch() {
    this.offcanvasHistory.dismiss();
  }


}
